<template>
  <div>
    <label v-if="label" class="col-form-label" :class="labelClass">
      {{ label }}
      <span class="text-danger" v-if="required === 'required'">*</span>
    </label>
    <textarea
      v-bind="$attrs"
      :id="label"
      :value="modelValue"
      @input="updateValue"
      v-on="listeners"
      class="form-control"
      :class="itemClass"
      :rows="rows"
      @blur="handleBlur"
      :maxLength="maxLength"
    />

    <span v-if="spinner" class="spinner-border spinner-border-sm text-success spinner-input me-1"></span>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    labelClass: {
      type: String,
      default: '',
      required: false
    },
    modelValue: [String, Number],
    itemClass: {
      type: String
    },
    required: {
      type: String,
      default: ''
    },
    spinner: {
      type: Boolean,
      default: false
    },
    rows: {
      type: [String, Number],
      default: null
    },
    maxLength: {
      type: Number,
      required: false,
      default: 1000
    }
  },
  emits: ['update:modelValue', 'blur'],
  methods: {
    updateValue(event) {
      this.$emit('update:modelValue', event.currentTarget.value)
    },
    handleBlur(e) {
      this.$emit('blur', e.target.value)
    }
  },
  computed: {
    listeners() {
      return {
        input: this.updateValue
      }
    }
  }
}
</script>

<style scoped>
.no-resize {
  resize: none;
}

textarea.error {
  border-color: #d64545;
}
</style>
